// 처음 배정값 창 모양 — 2026-11-03 InitialAssignmentDefaultsModal.jsx(300줄)에서 그대로 옮김(300줄 규칙, 동작 변화 없음).
export const wrapStyle = {
  display: 'grid',
  gap: 14,
};

export const noticeStyle = {
  margin: 0,
  padding: '10px 12px',
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'rgba(37,99,235,0.08)',
  color: 'var(--text-sub)',
  fontSize: 13,
  lineHeight: 1.5,
};

export const bodyStyle = {
  display: 'grid',
  gridTemplateColumns: '190px minmax(0, 1fr)',
  gap: 14,
  alignItems: 'start',
};

export const departmentPanelStyle = {
  display: 'grid',
  gap: 8,
  padding: 10,
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-card)',
};

export const panelTitleStyle = {
  margin: 0,
  color: 'var(--text)',
  fontSize: 13,
  fontWeight: 900,
};

export const departmentButtonStyle = {
  width: '100%',
  minHeight: 34,
  padding: '0 10px',
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg)',
  color: 'var(--text)',
  textAlign: 'left',
  fontSize: 13,
  fontWeight: 800,
  cursor: 'pointer',
};

export const selectedDepartmentButtonStyle = {
  ...departmentButtonStyle,
  borderColor: '#2563eb',
  background: 'rgba(37,99,235,0.1)',
  color: '#2563eb',
};

export const contentStyle = {
  display: 'grid',
  gap: 14,
  minWidth: 0,
};

export const sectionStyle = {
  display: 'grid',
  gap: 8,
};

export const sectionHeadStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
};

export const sectionTitleStyle = {
  margin: 0,
  fontSize: 15,
  fontWeight: 800,
  color: 'var(--text)',
};

export const optionGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
  gap: 8,
};

export const optionStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  minHeight: 38,
  padding: '8px 10px',
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-card)',
  color: 'var(--text)',
  fontSize: 13,
  fontWeight: 700,
};

export const countStyle = {
  color: 'var(--text-muted)',
  fontSize: 12,
  fontWeight: 800,
};
